// 倒计时额外增加的时间
export const EXTRA_TIME = 2
